export const buildNumber = '20260320.2';
export const version = 'main';
export const latestCommit = 'f2bcc080a59ff4602411b1ea30ad70a95a235e92';
